@if (content(); as content) {
  <div
    class="nordic-blue-900-bg surface-contrast white-text text-icon-reversed ps-xlarge br-large"
    [class.col-1-12]="isFullWidth()"
  >
    @if (content.title || content.teaserTitle) {
      <fcom-heading-tag
        data-testid="heading-tag"
        class="heading-tag"
        [level]="headerLevel()"
        [extraClasses]="headerFontLevel()"
        >{{ content.title || content.teaserTitle }}</fcom-heading-tag
      >
    }
    <div class="flex column-wrapper">
      @for (article of articles(); track article.contentId) {
        <div data-testid="article-with-icons-article" class="flex-1 flex--basis0">
          <cms-rich-text [content$]="article | finToObservable" [extraClasses]="link() ? '' : 'mr-large-b'" />
          @for (link of article.related ?? []; track $index) {
            <div class="flex nowrap">
              <cms-text-link [content$]="link | finToObservable" [colorClass]="'white-text text-icon-reversed'" />
            </div>
          }
        </div>
      }
    </div>

    @if (link(); as link) {
      <div class="flex flex--end mr-large-t">
        <a
          [finLink]="link.target?.url"
          [external]="link.target?.external"
          [attr.target]="link.target?.openInNewTab ? '_blank' : null"
          class="flex flex--middle white-text text-icon-reversed bold-type no-underline font-body-1 underline-hover font-body-medium-bold"
          data-testid="article-with-icons-cta"
        >
          <span class="title">{{ link.teaserTitle }}</span>
          <span class="cta">
            <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.ARROW_RIGHT" />
          </span>
        </a>
      </div>
    }
  </div>
}
